import { PermissionTypeEnum } from "../../../core/permission/PermissionTypeEnum";
import { PermissionResourcePayload } from "../../../core/services/permission-resource.service";

/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesRemuneration {
	PROPOSAL = "res://senior.com.br/hcm/remuneration/proposal",
	SALARY_INCREASE_RANKING = "res://senior.com.br/hcm/remuneration/dashboardManagerSalaryIncreaseRanking",
	SALARY_FRAMING = "res://senior.com.br/hcm/remuneration/employeeFramework",
	AVERAGE_TIME_SALARY_INCREASE = "res://senior.com.br/hcm/remuneration/averageSalaryIncreaseTime",
	REMUNERATION_VS_PERFORMANCE = "res://senior.com.br/hcm/remuneration/dashboardRemunerationVsPerformance",
	SALARY_EVOLUTION = "res://senior.com.br/hcm/remuneration/dashboardSalaryEvolution",
	LAST_SALARY_INCREASE = "res://senior.com.br/hcm/remuneration/lastSpontaneousSalaryIncrease",
	AVERAGE_SALARY = "res://senior.com.br/hcm/remuneration/salaryAverage",
	SALARY_DATA_MANAGER = "res://senior.com.br/hcm/remuneration/dashboardManagerSalaryData",
	SALARY_INCREASE_MANAGER = "res://senior.com.br/hcm/remuneration/dashboardManagerSalaryIncrease",
	EMPLOYEES_FRAMEWORK = "res://senior.com.br/hcm/remuneration/dashboardEmployeesFramework",
	REMUNERATION_AVERAGE_PROMOTION_TIME = "res://senior.com.br/hcm/remuneration/averagePromotionTime"
}

/**
 * Cards da página Manager, aba Remuneration
 */
export enum PermissionResourcesRemunerationManager {
	PROPOSAL = "res://senior.com.br/hcm/remuneration/proposal",
	SALARY_INCREASE_MANAGER = "res://senior.com.br/hcm/remuneration/dashboardManagerSalaryIncrease",
	SALARY_DATA_MANAGER = "res://senior.com.br/hcm/remuneration/dashboardManagerSalaryData",
	EMPLOYEES_FRAMEWORK = "res://senior.com.br/hcm/remuneration/dashboardEmployeesFramework",
	SALARY_INCREASE_RANKING = "res://senior.com.br/hcm/remuneration/dashboardManagerSalaryIncreaseRanking",
	REMUNERATION_VS_PERFORMANCE = "res://senior.com.br/hcm/remuneration/dashboardRemunerationVsPerformance",
	SALARY_EVOLUTION = "res://senior.com.br/hcm/remuneration/dashboardSalaryEvolution",
	REMUNERATION_AVERAGE_PROMOTION_TIME = "res://senior.com.br/hcm/remuneration/averagePromotionTime",
	AVERAGE_TIME_SALARY_INCREASE = "res://senior.com.br/hcm/remuneration/averageSalaryIncreaseTime"
}

/**
 * Cards da página Led, aba Remuneration
 */
export enum PermissionResourcesRemunerationLed {
	LAST_SALARY_INCREASE = "res://senior.com.br/hcm/remuneration/lastSpontaneousSalaryIncrease",
	SALARY_FRAMING = "res://senior.com.br/hcm/remuneration/employeeFramework"
}

export function remunerationSpecialPermissions(): PermissionResourcePayload[] {
	return [
		{
			resource: PermissionResourcesRemuneration.PROPOSAL,
			actions: [
				PermissionTypeEnum.APROVAR_REJEITAR,
				PermissionTypeEnum.VISUALIZAR
			]
		}
	];
}
